import { Check, Send } from "lucide-react";
import { SectionHeading, Reveal } from "@/components/Reveal";
import { TELEGRAM_URL } from "@/config";

const POINTS = [
    "Offerte selezionate",
    "Aggiornamenti frequenti",
    "Accesso gratuito",
    "Tutto direttamente su Telegram",
];

export default function WhyUs() {
    return (
        <section
            id="perche-noi"
            data-testid="perche-noi"
            className="grain relative scroll-mt-24 overflow-hidden bg-ink py-20 text-white sm:py-28"
        >
            <div className="absolute -left-40 top-1/4 h-[480px] w-[480px] rounded-full bg-telegram/25 blur-[140px]" />
            <div className="absolute -right-32 bottom-0 h-[380px] w-[380px] rounded-full bg-telegram-deep/20 blur-[120px]" />

            <div className="relative z-10 mx-auto grid max-w-7xl grid-cols-1 gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:gap-20 lg:px-8">
                <div className="lg:sticky lg:top-32 lg:self-start">
                    <SectionHeading
                        light
                        align="left"
                        eyebrow="Perché sceglierci"
                        title="Non tutte le offerte sono davvero offerte."
                        sub="Su Amazon ci sono migliaia di promozioni ogni giorno. Noi cerchiamo di separare le occasioni realmente interessanti dal semplice marketing."
                    />
                    <Reveal delay={0.25}>
                        <a
                            href={TELEGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="why-telegram-cta"
                            className="mt-9 inline-flex items-center gap-2.5 rounded-full bg-telegram px-7 py-3.5 text-sm font-bold text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-telegram-glow hover:shadow-[0_16px_36px_-10px_rgba(34,158,217,0.55)]"
                        >
                            <Send className="h-4 w-4" />
                            Entra nel canale
                        </a>
                    </Reveal>
                </div>

                <div>
                    {POINTS.map((p, i) => (
                        <Reveal key={p} delay={i * 0.1}>
                            <div
                                data-testid={`why-point-${i}`}
                                className="group flex items-center gap-5 border-b border-white/10 py-7 transition-all duration-500 first:border-t hover:translate-x-2"
                            >
                                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-telegram/15 ring-1 ring-telegram/40 transition-all duration-500 group-hover:bg-telegram group-hover:shadow-[0_10px_25px_-8px_rgba(34,158,217,0.6)]">
                                    <Check strokeWidth={3} className="h-5 w-5 text-telegram-glow transition-colors duration-500 group-hover:text-white" />
                                </span>
                                <span className="font-display text-xl font-semibold tracking-tight sm:text-2xl">{p}</span>
                                <span aria-hidden className="ml-auto font-mono text-xs text-white/25">
                                    0{i + 1}
                                </span>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
